import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getZoneData } from '@/store/tickets-zone-capacity/mockMaxCapacity';

function useMaxCapacityByTicket(ticketID) {
  const ticket = useSelector((state) => state.ticketTypes.entities[ticketID]);
  const tickets = useSelector((state) =>
    state.ticketTypes.ids.map((id) => state.ticketTypes.entities[id]),
  );

  const {
    event: { id, user_id },
  } = useSelector((state) => state.event || { event: {} });
  const [zone, setZone] = useState();

  const getZoneAvailability = (zoneID) => {
    let availability = 0;
    tickets.map((t) => {
      if (t.zone === zoneID) {
        const currentAvailability = t.quantity - t.availability;
        availability += currentAvailability;
      }
    });
    return availability;
  };

  const zoneCount = useSelector((state) => {
    if (ticket && state.ticketsSelected.ids.length > 0) {
      let counter = 0;
      Object.values(state.ticketsSelected.entities).map((entity) => {
        if (ticket.zone === entity.zone) {
          counter += entity.quantity;
        }
      });
      return counter;
    }
    return 0;
  });

  useEffect(() => {
    if (zone && ticket) {
      let currentZone = getZoneData(user_id, id, ticket.name);
      if (currentZone) {
        const availability = getZoneAvailability(currentZone.id);
        currentZone = {
          ...currentZone,
          availability,
        };
      }

      setZone(currentZone);
    }
  }, [ticket, tickets, id, user_id]);

  return {
    zone,
    zoneCount,
  };
}

export { useMaxCapacityByTicket };
